import { cn } from '@/lib/utils';

export const RICH_TEXT_PROSE_CLASS = 'prose max-w-none text-inherit [&_*]:text-inherit';

export const INLINE_RICH_TEXT_FIELD_CLASS = cn(RICH_TEXT_PROSE_CLASS, 'tiptap w-full outline-none');

export const RICH_TEXT_IDLE_PLACEHOLDER_CLASS = 'rich-text-idle-placeholder';

export const INLINE_RICH_TEXT_CONTENT_CLASS = cn(
  RICH_TEXT_PROSE_CLASS,
  'tiptap min-h-8 break-words whitespace-break-spaces [font-variant-ligatures:none] [font-feature-settings:"liga"_0]',
);

export const INLINE_RICH_TEXT_SURFACE_CLASS =
  'rounded-md outline-none ring-1 ring-transparent transition-[box-shadow]';

export const INLINE_RICH_TEXT_EDIT_SURFACE_CLASS = 'hover:bg-primary/4 focus-visible:bg-primary/6';

const INLINE_RICH_TEXT_CHROME_BASE_CLASS =
  'rounded-md ring-2 ring-transparent transition-[box-shadow,background-color] duration-150 ease-out';

const INLINE_RICH_TEXT_CHROME_HOVER_CLASS = 'hover:ring-editor-primary/35';
const INLINE_RICH_TEXT_CHROME_SELECTED_CLASS = 'ring-editor-primary/70';

export const INLINE_RICH_TEXT_EDIT_CURSOR_CLASS = 'cursor-text';

export function inlineRichTextFieldChromeClass({
  isSelected = false,
  isEditing = false,
  className,
}: {
  isSelected?: boolean;
  isEditing?: boolean;
  className?: string;
} = {}) {
  return cn(
    INLINE_RICH_TEXT_CHROME_BASE_CLASS,
    !isEditing && !isSelected && INLINE_RICH_TEXT_CHROME_HOVER_CLASS,
    (isSelected || isEditing) && INLINE_RICH_TEXT_CHROME_SELECTED_CLASS,
    className,
  );
}

export function inlineRichTextPreviewCursorClass(dragDisabled?: boolean) {
  return dragDisabled ? 'cursor-default' : 'cursor-pointer active:cursor-grabbing';
}
